import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Field } from "@progress/kendo-react-form";
import { FormInput, FormDropDownListById, FormCheckbox} from "../../forms/form-components";
import { sortDirections, getWidgetFontColors, fontSizes, widgetAllAggregateFunctions, 
         chartLegendPositions, WIDGET_LINE_CHART, lineChartStyles, isMinMaxChart,
         WIDGET_PIE_CHART, WIDGET_DOUGHNUT_CHART, WIDGET_FUNNEL_CHART, WIDGET_WATERFALL_CHART,
        WIDGET_RANGEBAR_CHART, WIDGET_RANGEAREA_CHART} from "./utils";        
import { getDataTypeIcon, getExpressionIcon, isNumeric } from "../../lib/utils";
import { useTranslation } from "react-i18next";
        

export const GenericChartWidgetSettings = props => {
    const currentTheme = useSelector(state => state.currentTheme);
    const fontColors= getWidgetFontColors(currentTheme);
    const {pageState, formState, onFieldValueChange, formRenderProps, ...other} = props;
    const { t } = useTranslation();

    let dataSourceTitle = formState.formValues.settings.dataSourceTitle;
    if(!dataSourceTitle)//the report is in view mode
    {
        let dataSource = formState.dataSources.find(e => e.Id == formState.formValues.dataSourceId);
        if (!dataSource.IsImplicit)
            dataSourceTitle = dataSource.Title;
        else
            dataSourceTitle = formState.formValues.settings.schema[0].Title;
    }

    let fields = [...formState.formValues.settings.fields];//.sort((a,b) => (a.title <= b.title) ? -1 : 1);
    let numericFields = fields.filter(e => e.id == 0 || e.dataTypeId == 2);    
    let widgetTypeId = formState.widgetTypeId;
    let _isMinMaxChart = isMinMaxChart(widgetTypeId);

    let reportIsInViewMode = pageState.reportIsInViewMode;

    return (
        <Fragment>
            <div className="generic-chart-settings">          
                <div className="widget-settings-form-group" style={{marginBottom: 0}}>
                    <div className="header">
                        {t("extras.widget")}
                    </div>
                    <div className="content">
                        {
                            formState.mode == 2 && 
                            <div className="row" style={{alignItems: "center", justifyContent: "flex-start"}}>
                                <div style={{fontWeight: 600}}>{t("extras.datasource")}</div>
                                <div style={{marginLeft: 16}}>
                                    {dataSourceTitle}
                                </div>
                            </div>
                        }
                        <div className="row" style={{alignItems: "center", justifyContent: "flex-start"}}>
                            <div style={{width: 125}}>
                                <Field
                                    id={"settings.maximumRows"}
                                    name={"settings.maximumRows"}
                                    label={t("extras.maxRows")}
                                    type={"number"}
                                    component={FormInput}
                                    maxLength={7}
                                    style={{width:"100%"}}
                                    onChange={e => onFieldValueChange({id: "maximumRows", value: isNumeric(e.target.value) ? parseFloat(e.target.value) : e.target.value})}
                                    />
                            </div>
                            <div style={{width:125, marginLeft: 24}}>
                                <Field 
                                    id={"settings.reorderable"}
                                    name={"settings.reorderable"}
                                    label={t("extras.draggable")}
                                    component={FormCheckbox}
                                    onChange={e => onFieldValueChange({id: "reorderable", value: e.value})}
                                    />
                            </div>
                            <div style={{width:125, marginLeft: 24}}>
                                <Field 
                                    id={"settings.resizable"}
                                    name={"settings.resizable"}
                                    label={t("extras.resizable")}
                                    component={FormCheckbox}                                  
                                    onChange={e => onFieldValueChange({id: "resizable", value: e.value})}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="widget-settings-form-group" style={{marginBottom: 6}}>
                    <div className="header">
                        {t("extras.title")}
                    </div>
                    <div className="content">
                        <div className="row">
                            <Field
                                id={"settings.title"}
                                name={"settings.title"}
                                component={FormInput}
                                maxLength={255}
                                style={{width:"100%"}}
                                onChange={e => onFieldValueChange({id: "title", value: e.target.value})}
                                />
                        </div>
                        <div className="row">
                            <div style={{width:165}}>
                                <Field
                                    id={"settings.titleFontColor"}
                                    name={"settings.titleFontColor"}
                                    label={t("extras.color*")}
                                    component={FormDropDownListById}
                                    data={fontColors} dataItemKey="id" textField="title"  
                                    onChange={e => onFieldValueChange({id: "titleFontColor", value: e.value})}
                                    />
                            </div>
                            <div style={{width:165, marginLeft: 24}}>
                                <Field
                                    id={"settings.titleFontSize"}
                                    name={"settings.titleFontSize"}
                                    label={t("extras.size")} 
                                    component={FormDropDownListById}
                                    data={fontSizes} dataItemKey="id" textField="title"  
                                    style={{marginTop:2}}
                                    onChange={e => onFieldValueChange({id: "titleFontSize", value: e.value})}
                                    />
                            </div>                            
                            <div style={{display: "flex", flex: 1}}>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsBold"}
                                        name={"settings.titleFontIsBold"}
                                        label={t("extras.bold")} 
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsBold", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsUnderline"}
                                        name={"settings.titleFontIsUnderline"}
                                        label={t("extras.underline")} 
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsUnderline", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsItalic"}
                                        name={"settings.titleFontIsItalic"}
                                        label={t("extras.italic")} 
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsItalic", value: e.value})}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="widget-settings-form-group" style={{marginBottom: 0}}>
                    <div className="header">
                        {t("extras.chart")} 
                    </div>
                    <div className="content">
                    {
                        fields && fields.length > 0 && 
                        <Fragment>
                            <div className="row" style={{alignItems: "flex-start", marginBottom: 16}}>
                                <div style={{flex: 1}}>
                                    <Field
                                        id={"settings.categoryFieldId"}
                                        name={"settings.categoryFieldId"}
                                        label={t("extras.xaxis")} 
                                        component={FormDropDownListById}
                                        data={fields} dataItemKey="id" textField="title" 
                                        onChange={e => onFieldValueChange({id: "categoryFieldId", value: e.value})}
                                        disabled={reportIsInViewMode}
                                        />
                                </div>                                                            
                                <div style={{flex: 1, marginLeft: 24}}>
                                    <Field
                                        id={"settings.valueFieldId"}
                                        name={"settings.valueFieldId"}
                                        label={t("extras.yaxis")} 
                                        component={FormDropDownListById}
                                        data={numericFields} dataItemKey="id" textField="title" 
                                        onChange={e => onFieldValueChange({id: "valueFieldId", value: e.value})}
                                        disabled={reportIsInViewMode}
                                        />
                                </div>                                
                            </div>    
                            <div className="row" style={{alignItems: "flex-start", marginBottom: 16}}>
                             <div style={{flex: 1}}>
                                    <Field
                                        id={"settings.aggregate"}
                                        name={"settings.aggregate"}
                                        label={`${t("extras.aggregate")}${_isMinMaxChart ? "" : "*"}`}
                                        component={FormDropDownListById}
                                        data={widgetAllAggregateFunctions} dataItemKey="id" textField="title"  
                                        onChange={e => onFieldValueChange({id: "aggregate", value: e.value})}
                                        disabled={reportIsInViewMode}
                                        />
                                </div>           
                            {
                                widgetTypeId != WIDGET_PIE_CHART && widgetTypeId != WIDGET_DOUGHNUT_CHART && 
                                widgetTypeId != WIDGET_WATERFALL_CHART && widgetTypeId != WIDGET_FUNNEL_CHART &&
                                <div style={{flex: 1, marginLeft: 24}}>
                                    <Field
                                        id={"settings.secondaryFieldId"}
                                        name={"settings.secondaryFieldId"}
                                        label={t("extras.secField")}  
                                        disabled={reportIsInViewMode || formState.mode == 2}
                                        component={FormDropDownListById}
                                        data={fields} dataItemKey="id" textField="title" 
                                        onChange={e => onFieldValueChange({id: "secondaryFieldId", value: e.value})}
                                        />
                                </div>
                            }                                                        
                            </div>            
                            {
                                widgetTypeId != WIDGET_PIE_CHART && widgetTypeId != WIDGET_DOUGHNUT_CHART &&     
                                <div className="row" style={{alignItems: "flex-start", marginBottom: 16}}>
                                    <div style={{flex: 1}}>
                                        <Field
                                            id={"settings.sortFieldId"}
                                            name={"settings.sortFieldId"}
                                            label={t("extras.sortField")}  
                                            component={FormDropDownListById}
                                            data={fields} dataItemKey="id" textField="title" 
                                            onChange={e => onFieldValueChange({id: "sortFieldId", value: e.value})}
                                            />
                                    </div>
                                    <div style={{flex: 1, marginLeft: 24}}>
                                        <Field
                                            id={"settings.sortFieldDirectionId"}
                                            name={"settings.sortFieldDirectionId"}
                                            label={t("extras.direction")}   
                                            component={FormDropDownListById}
                                            data={sortDirections} dataItemKey="id" textField="title" 
                                            onChange={e => onFieldValueChange({id: "sortFieldDirectionId", value: e.value})}
                                            />
                                    </div>
                                </div>
                            }
                            {
                                widgetTypeId != WIDGET_PIE_CHART && widgetTypeId != WIDGET_DOUGHNUT_CHART &&
                                widgetTypeId != WIDGET_RANGEBAR_CHART && widgetTypeId != WIDGET_RANGEAREA_CHART &&
                                <div className="row" style={{alignItems: "flex-start", marginBottom: 16}}>
                                    <div style={{flex: 1}}>
                                        <Field
                                            id={"settings.topDirectionId"}
                                            name={"settings.topDirectionId"}
                                            label={t("extras.filterYaxis")}    
                                            component={FormDropDownListById}
                                            data={[{id: 0, title: "All"}, {id:1, title: "Bottom"}, {id:2, title: "Top"}]} dataItemKey="id" textField="title"  
                                            onChange={e => onFieldValueChange({id: "topDirectionId", value: e.value})}
                                            />
                                    </div>

                                    <div style={{flex: 1, marginLeft: 24}}>
                                        <Field
                                            id={"settings.topCount"}
                                            name={"settings.topCount"}
                                            label={t("extras.count")}   
                                            component={FormInput}
                                            maxLength={5}
                                            style={{width:"100%"}} type="number"
                                            onChange={
                                                e => {onFieldValueChange({id: "topCount", value: isNumeric(e.target.value) ? parseFloat(e.target.value) : e.target.value})}
                                            }
                                            />
                                    </div>
                                </div>
                            }

                            <div className="row" style={{alignItems: "flex-start", marginBottom: 0}}>
                                <div style={{flex:1 }}>
                                    <Field
                                        id={"settings.legendPosition"}
                                        name={"settings.legendPosition"}
                                        label={t("extras.legendPosition")}    
                                        component={FormDropDownListById}
                                        data={chartLegendPositions} dataItemKey="id" textField="title"  
                                        onChange={e => onFieldValueChange({id: "legendPosition", value: e.value})}
                                        />
                                </div>
                                {
                                    widgetTypeId == WIDGET_LINE_CHART && 
                                    <div style={{flex: 1, marginLeft: 24}}>
                                        <Field
                                            id={"settings.lineStyle"}
                                            name={"settings.lineStyle"}
                                            label={t("extras.lineStyle")}    
                                            component={FormDropDownListById}
                                            data={lineChartStyles} dataItemKey="id" textField="title"  
                                            onChange={e => onFieldValueChange({id: "lineStyle", value: e.value})}
                                            />
                                    </div>
                                }                       
                            </div>                            
                        </Fragment>
                    }
                    </div>
                </div>
                           
            </div>
            <style>
                {
                    `
                        .widget-settings-form-group:nth-child(2) .k-form-field:first-of-type
                        {
                            width: 100%;
                        }
                       
                        .generic-chart-settings
                        {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                        }
                      
                    `
                }
            </style>
        </Fragment>
    );
};
